import { useState, useEffect, useRef } from 'react';

interface TextFilterProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
}

export function TextFilter({ value, onChange, placeholder = 'Search...' }: TextFilterProps) {
  const [localValue, setLocalValue] = useState(value);
  const debounceRef = useRef<ReturnType<typeof setTimeout>>();
  const inputRef = useRef<HTMLInputElement>(null);

  // Focus on mount
  useEffect(() => {
    inputRef.current?.focus();
  }, []);

  // Sync local value with prop
  useEffect(() => {
    setLocalValue(value);
  }, [value]);

  // Debounce changes
  useEffect(() => {
    if (debounceRef.current) {
      clearTimeout(debounceRef.current);
    }
    debounceRef.current = setTimeout(() => {
      if (localValue !== value) {
        onChange(localValue);
      }
    }, 300);
    return () => {
      if (debounceRef.current) {
        clearTimeout(debounceRef.current);
      }
    };
  }, [localValue, value, onChange]);

  return (
    <input
      ref={inputRef}
      type="text"
      value={localValue}
      onChange={(e) => setLocalValue(e.target.value)}
      placeholder={placeholder}
      className="w-full px-3 py-2 text-sm border border-sage-200 rounded-lg focus:border-forest-500 focus:outline-none focus:ring-1 focus:ring-forest-500"
    />
  );
}
